// extracted by mini-css-extract-plugin
export var contentBody = "_do-9";
export var headerImage = "_do-2";
export var imageButton = "_do-7";
export var imageButtonIcon = "_do-8";
export var imageHeader = "_do-4";
export var imageHeaderText = "_do-5";
export var imageOverlay = "_do-3";
export var imageTitle = "_do-6";
export var imageWrapper = "_do-1";
export var taskList = "_do-a";
export var widget = "_do-0";